import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { Icon } from '@ibk/shared-ui';
import styles from './SearchBar.module.css';
export function SearchBar({ value, onChange, placeholder, ariaLabel = 'Search input', className, inputClassName, }) {
    function handleChange(event) {
        onChange(event.target.value);
    }
    const containerClassName = className ? `${styles.container} ${className}` : styles.container;
    const inputFieldClassName = inputClassName ? `${styles.input} ${inputClassName}` : styles.input;
    return (_jsxs("div", { className: containerClassName, children: [_jsx(Icon, { name: 'search', className: styles.searchIcon }), _jsx("input", { type: 'text', maxLength: 200, value: value, onChange: handleChange, placeholder: placeholder, "aria-label": ariaLabel, className: inputFieldClassName })] }));
}
export default SearchBar;
